"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnavailableChip = exports.ErrorChip = exports.Chip = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = _interopRequireWildcard(require("./theme"));
var _constants = require("../../utils/constants");
var _icon_buttons = _interopRequireDefault(require("../buttons/icon_buttons"));
var _close = _interopRequireDefault(require("../../icons/close"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ThemeableChip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var theme = props.theme,
    onRemove = props.onRemove,
    text = props.text,
    title = props.title,
    truncated = props.truncated;
  var ChipTextComponent = theme.typography;
  return /*#__PURE__*/React.createElement(ChipWrapper, (0, _extends2["default"])({
    ref: ref,
    title: title || text,
    $removable: !!onRemove,
    $theme: theme
  }, (0, _constants.getDataProvidesProps)(props)), /*#__PURE__*/React.createElement(ChipTextComponent, {
    $truncated: truncated
  }, text), onRemove && /*#__PURE__*/React.createElement(CloseIconWrapper, null, /*#__PURE__*/React.createElement(_icon_buttons["default"], {
    icon: _close["default"],
    size: 'seedling-only-sm',
    onClick: onRemove,
    "data-provides": "remove-chip",
    label: "Remove ".concat(text),
    flat: true
  })));
});
ThemeableChip.displayName = 'ThemeableChip';
ThemeableChip.defaultProps = {
  truncated: true
};
var CloseIconWrapper = _styledComponents["default"].span.withConfig({
  displayName: "chips__CloseIconWrapper"
})(["svg{background:", ";path{fill:", ";}&:hover{border-radius:50%;cursor:pointer;background:", ";path{fill:", ";}}}&:focus-within{background:", ";path{fill:", ";}}&:active{background:", ";path{fill:", ";}}&&& > button{background:", ";margin:0 -2px -1px -2px;padding:2px;&&&:focus-within{background:", ";}&&&:active{background:", ";}}"], _theme.CloseIconTheme["default"].backgroundColor, _theme.CloseIconTheme["default"].color, _theme.CloseIconTheme.hover.backgroundColor, _theme.CloseIconTheme.hover.color, _theme.CloseIconTheme["default"].backgroundColor, _theme.CloseIconTheme.hover.color, _theme.CloseIconTheme["default"].backgroundColor, _theme.CloseIconTheme.hover.color, _theme.CloseIconTheme["default"].backgroundColor, _theme.CloseIconTheme["default"].backgroundColor, _theme.CloseIconTheme["default"].backgroundColor);
var ChipWrapper = _styledComponents["default"].span.attrs(function (props) {
  return {
    'data-provides': props['data-provides'] || 'chip-wrapper',
    title: props.title
  };
}).withConfig({
  displayName: "chips__ChipWrapper"
})(["display:inline-flex;align-items:center;justify-content:space-between;gap:0.25rem;height:1.5rem;background:", ";border:1px solid ", ";border-radius:5px;box-sizing:border-box;line-height:100%;padding-left:0.5rem;padding-top:0.125rem;padding-bottom:0.125rem;padding-right:", "rem;white-space:nowrap;&:hover{border:1px solid ", ";}"], function (_ref) {
  var $theme = _ref.$theme;
  return $theme.backgroundColor;
}, function (_ref2) {
  var $theme = _ref2.$theme;
  return $theme.borderColor;
}, function (props) {
  return props.$removable ? "0.25" : "0.5";
}, function (_ref3) {
  var $theme = _ref3.$theme;
  return $theme.hoverBorderColor;
});
var Chip = exports.Chip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ThemeableChip, (0, _extends2["default"])({}, props, {
    theme: _theme["default"]["default"],
    ref: ref
  }));
});
Chip.displayName = 'Chip';
Chip.defaultProps = {
  'data-provides': 'default-chip'
};
var ErrorChip = exports.ErrorChip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ThemeableChip, (0, _extends2["default"])({}, props, {
    theme: _theme["default"].error,
    ref: ref
  }));
});
ErrorChip.displayName = 'ErrorChip';
ErrorChip.defaultProps = {
  'data-provides': 'error-chip'
};
var UnavailableChip = exports.UnavailableChip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(ThemeableChip, (0, _extends2["default"])({}, props, {
    theme: _theme["default"].unavailable,
    ref: ref
  }));
});
UnavailableChip.displayName = 'UnavailableChip';
UnavailableChip.defaultProps = {
  'data-provides': 'unavailable-chip'
};